import router from "@/router";
export default {
  namespaced: true,
  state: {
    openRoleDialog: false,
    roleName: "",
    isSnackbar: false,
    openProfileModal: false,
    userDeatils: [],
    isLoader: false,
  },
  mutations: {
    setModal(state, payload) {
      state.openRoleDialog = payload.roleDialog;
      state.roleName = payload.role;
    },
    setProfileFormModal(state, payload) {
      state.openProfileModal = payload.roleDialog;
      state.userDeatils = payload.userData;
    },

    setSnackbar(state, payload) {
      state.isSnackbar = payload;
    },

    setLoader(state, payload) {
      state.isLoader = payload;
    },
  },
  getters: {},
  actions: {},
};
